export const stylistReducer = (state = "", action) => {
  switch (action.type) {
    case "SET_STYLIST_DETAILS":
      return action.payload;
    default:
      return state;
  }
};
